
<template>
  <div class="confirm" @click="lockSeat()">
    <div class="dib c-d1" v-show="selectedSeat.length != 0">
      {{ selectedSeat.length }}张
    </div>
    <div class="dib c-d2" v-show="selectedSeat.length != 0">
      {{ $utils.getPricePoint(this.keepTwoDecimalFull(sale_price)) }}点
    </div>
    <!-- <div class="dib c-d1" v-show="selectedSeat.length != 0">
      省￥{{ this.keepTwoDecimalFull(save_price) }}&nbsp;<i style="text-decoration: line-through">市场价￥{{ this.keepTwoDecimalFull(chPrice) }}</i>
    </div> -->
    {{ selectedSeat.length != 0 ? "确认" : "请先" }}选座

  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    propSelectedSeat: Array,
    propSeatList: Array,
    propCardId: String,
    propfilm_id: String,
    propHallName: String,
    propShowDate: String,
    propShowTime: String,
    propcinema: String,
    propiscOrder: Boolean,
    movieName: String,
    showtype: String,
    movieAddress: String,
    moviePicUrl: String,
    propPriceKey: String,
    propCinemaId: String,
  },
  data() {
    return {
      selectedSeat: this.propSelectedSeat,
      seatList: this.propSeatList,
    }
  },
  computed: {
    // 市场原价
    chPrice() {
      let totalPrice = 0
      for (const seat of this.selectedSeat) {
        totalPrice += seat.price
      }
      return totalPrice
    },
    // 售卖价格
    sale_price() {
      let totalPrice = 0
      for (const seat of this.selectedSeat) {
        totalPrice += parseFloat(seat.price)
      }
      return parseFloat(totalPrice).toFixed(2)
    },
    // 座位编号字符串
    seatIdListStr() {
      return this.selectedSeat.map(seat => seat.seatNo).join(',')
    },
  },
  watch: {
    propSelectedSeat(val) {
      this.selectedSeat = val
    },
    propSeatList(val) {
      this.seatList = val
    },
    propiscOrder(val) {
      if (val) {
        this.createOrder()
      } else {
        this.$Toast.fail('下单参数异常~')
      }
    }
  },

  // 方法集合
  methods: {
    /**
     * 孤岛座位检查 - 核心算法
     * 规则：选座后，同一排内不能产生被"占用座位"夹住的单独1个空位
     * "占用座位"包括：已选(selectedIcon)、已售(soldedIcon)
     * 
     * 算法思路：
     * 1. 找出所有受影响的行（已选座位所在的行）
     * 2. 对每一行，检查是否存在孤岛空位
     * 3. 孤岛定义：一个空位，其左右两侧紧邻的都是"占用座位"或边界/过道
     */
    checkAdjacent: function () {
      // 获取所有已选座位所在的行号
      const affectedRows = [...new Set(this.selectedSeat.map(s => s.rowNo))]
      
      // 对每一行进行孤岛检查
      for (const rowNo of affectedRows) {
        if (!this.checkRowForIsland(rowNo)) {
          return false
        }
      }
      return true
    },

    /**
     * 检查某一行是否因用户选座而产生新的孤岛座位
     * @param {number} rowNo - 行号
     * @returns {boolean} - true表示没有新孤岛，false表示会产生新孤岛
     */
    checkRowForIsland(rowNo) {
      // 获取该行所有座位，并按列号排序
      const rowSeats = this.seatList
        .filter(seat => seat.rowNo === rowNo)
        .sort((a, b) => a.columnNo - b.columnNo)
      
      if (rowSeats.length === 0) return true

      // 获取该行中用户已选座位的列号集合
      const selectedColumnNos = new Set(
        this.selectedSeat
          .filter(s => s.rowNo === rowNo)
          .map(s => s.columnNo)
      )

      // 遍历该行每个座位，找出所有"可选空位"
      for (let i = 0; i < rowSeats.length; i++) {
        const seat = rowSeats[i]
        
        // 只检查"可选空位"（未选、未售、未损坏）
        if (!this.isSeatAvailable(seat)) continue

        // 检查这个空位是否与用户选择的座位相邻
        // 如果不相邻，说明这个空位的状态不受用户选座影响，跳过
        const leftColumnNo = seat.columnNo - 1
        const rightColumnNo = seat.columnNo + 1
        const isAdjacentToSelected = selectedColumnNos.has(leftColumnNo) || selectedColumnNos.has(rightColumnNo)
        
        if (!isAdjacentToSelected) continue

        // 这个空位与用户选择相邻，需要检查是否会成为孤岛
        if (this.isIslandSeat(rowSeats, i)) {
          return false // 会产生新孤岛，检查失败
        }
      }
      return true // 不会产生新孤岛
    },

    /**
     * 判断座位是否可选（未被选中、未售出、未损坏）
     */
    isSeatAvailable(seat) {
      return seat.nowIcon !== seat.selectedIcon && 
             seat.nowIcon !== seat.soldedIcon &&
             seat.nowIcon !== seat.fixIcon &&
             seat.canClick !== false
    },

    /**
     * 判断座位是否被占用（已选、已售或损坏）
     */
    isSeatOccupied(seat) {
      return seat.nowIcon === seat.selectedIcon || 
             seat.nowIcon === seat.soldedIcon ||
             seat.nowIcon === seat.fixIcon ||
             seat.canClick === false
    },

    /**
     * 检查指定位置的空位是否会形成孤岛
     * 孤岛定义：一个空位，左右两侧都被"占用"（已选/已售/边界/过道）
     * 
     * @param {Array} rowSeats - 该行所有座位（已排序）
     * @param {number} index - 当前座位在数组中的索引
     * @returns {boolean} - true表示是孤岛
     */
    isIslandSeat(rowSeats, index) {
      const seat = rowSeats[index]
      const prevSeat = index > 0 ? rowSeats[index - 1] : null
      const nextSeat = index < rowSeats.length - 1 ? rowSeats[index + 1] : null

      // 检查左侧状态
      let leftBlocked = false
      if (!prevSeat) {
        // 左边是边界
        leftBlocked = true
      } else if (prevSeat.columnNo !== seat.columnNo - 1) {
        // 左边有过道（列号不连续）
        leftBlocked = true
      } else if (this.isSeatOccupied(prevSeat)) {
        // 左边座位被占用
        leftBlocked = true
      }

      // 检查右侧状态
      let rightBlocked = false
      if (!nextSeat) {
        // 右边是边界
        rightBlocked = true
      } else if (nextSeat.columnNo !== seat.columnNo + 1) {
        // 右边有过道（列号不连续）
        rightBlocked = true
      } else if (this.isSeatOccupied(nextSeat)) {
        // 右边座位被占用
        rightBlocked = true
      }

      // 左右都被阻挡 = 孤岛
      return leftBlocked && rightBlocked
    },

    lockSeat: function () {
      let _this = this
      // 防止连点
      let check = _this.$once(new Date().getTime())
      if (!check) {
        return
      }
      if (_this.selectedSeat.length === 0) {
        this.$Toast.fail('请至少选择一个座位~')
        return
      }
      let result = _this.checkAdjacent()
      // 开始计算是否留下空位 ------------ 结束
      if (!result) {
        // 如果 result 为false
        this.$Toast.fail('请选择相邻座位')
      } else {
        if (_this.chPrice === 0) {
          this.$Toast.fail('锁座失败了~,金额为0')
          return
        }
        // 允许锁座
        this.createOrder()
      }
    },
    createOrder() {
      localStorage.setItem('film_id', this.propfilm_id)
      localStorage.setItem('seatList', JSON.stringify(this.propSelectedSeat))
      localStorage.setItem('sale_price', this.$utils.getPricePoint(this.keepTwoDecimalFull(this.sale_price)))
      this.lockseat()
    },


    lockseat() {
      const form = {
        cityCode: this.cityCode,
        filmId: this.propfilm_id,
        filmName: this.movieName,
        productNum: this.propSelectedSeat.length,
        productTotal: this.$utils.getPricePoint(this.sale_price),
        seatInfoList: this.getFormSeat(),
        orderDetail: this.getMovieDetail(),
        // 添加必要的查询参数，供后端重新计算价格
        cardId: this.propCardId,
        priceKey: this.propPriceKey,
      }
      localStorage.setItem('lockseatform', JSON.stringify(form))
      this.toConfig()
    },
    getMovieDetail() {
      let moveDetail = {}
      moveDetail.movieName = this.movieName
      moveDetail.hallType = this.showtype
      moveDetail.cinemaName = this.propcinema
      moveDetail.cinemaAddress = this.movieAddress
      moveDetail.hallName = this.propHallName
      moveDetail.seatNames = this.seatIdListStr
      moveDetail.moviePlayTime = this.propShowDate + ' ' + this.propShowTime
      moveDetail.moviePicUrl = this.moviePicUrl
      moveDetail.cardId = this.cardId
      moveDetail.cinemaId = this.propCinemaId
      return JSON.stringify(moveDetail)
    },
    getFormSeat() {
      let setList = []
      this.propSelectedSeat.forEach(element => {
        let seat = {}
        seat.seatId = element.seatId
        seat.showPrice = element.price
        setList.push(seat)
      });
      return setList
    },
    toConfig() {
      this.$router.push({
        path: "/ConfigOrder",
      });
    },
    // 四舍五入保留2位小数（不够位数，则用0替补）
    keepTwoDecimalFull(num) {
      let result = parseFloat(num)
      if (isNaN(result)) {
        return false
      }
      result = Math.round(num * 100) / 100
      let sxa = result.toString()
      let posdecimal = sxa.indexOf('.')
      if (posdecimal < 0) {
        posdecimal = sxa.length
        sxa += '.'
      }
      while (sxa.length <= posdecimal + 2) {
        sxa += '0'
      }
      return sxa
    }
  },
  mounted() {
    this.cityCode = localStorage.getItem("cityCode");
    this.cardId = localStorage.getItem("cardId");
  },
}
</script>
<style lang='scss' scoped='scoped'>
.confirm {
  border-radius: 1.5rem;
  position: fixed;
  bottom: 0;
  z-index: 10;
  width: calc(100% - 2rem);
  background: linear-gradient(135deg, #ff6b4a 0%, #ff8a65 100%);
  text-align: center;
  color: white;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.9rem 0;
  margin-bottom: 1rem;
  box-shadow: 0 4px 15px rgba(255, 107, 74, 0.35);
  transition: all 0.2s ease;

  &:active {
    opacity: 0.9;
    transform: scale(0.98);
  }
}

.dib {
  display: inline-block;
}

.c-d1 {
  font-size: 0.85rem;
  margin-right: 0.5rem;
  opacity: 0.95;
}

.c-d2 {
  font-weight: 700;
  margin-right: 0.5rem;
  font-size: 1.1rem;
}
</style>
